"use strict";

exports.__esModule = true;

exports.default = function (strings, raw) {
  strings.raw = raw;
  return strings;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/helpers/taggedTemplateLiteralLoose.js
// module id = 29
// module chunks = 1